module.exports = __webpack_public_path__ + "img/domestic-2018-youth-bluebook.94f1b416.jpg";